import { getLoader } from '@lasso/shared/utils'

const getSidenavCollapsed = () => {
  const item = localStorage.getItem('imos:sidenavCollapsed')

  if (!item) {
    return false
  }

  try {
    return JSON.parse(item)?.value === true
  } catch {
    return false
  }
}

const sidenavLoader = getLoader('sidenav')

if (sidenavLoader) {
  sidenavLoader.classList.toggle('collapsed', getSidenavCollapsed())
}
